(function () {
  'use strict';

  var sbbNamespace = window.__SBB__ = window.__SBB__ || {};

  function getScaleBarBuilderConstructor() {
    return sbbNamespace.ScaleBarBuilder;
  }

  function mountScaleBarBuilder(target) {
    var root = typeof target === 'string' ? document.querySelector(target) : target;
    if (!root) {
      return null;
    }

    if (root.__sbbMounted) {
      return root.__sbbMounted;
    }

    var ScaleBarBuilder = getScaleBarBuilderConstructor();
    if (typeof ScaleBarBuilder !== 'function') {
      if (typeof console !== 'undefined' && console.error) {
        console.error('ScaleBarBuilder core is not loaded before bootstrap.');
      }
      return null;
    }

    var app = new ScaleBarBuilder(root);
    root.__sbbMounted = app;
    return app;
  }

  function unmountScaleBarBuilder(target) {
    var root = typeof target === 'string' ? document.querySelector(target) : target;
    if (!root || !root.__sbbMounted) {
      return false;
    }
    if (typeof root.__sbbMounted.destroy === 'function') {
      root.__sbbMounted.destroy();
    } else {
      delete root.__sbbMounted;
    }
    return true;
  }

  function forEachBuilderRoot(container, callback) {
    if (!container || typeof callback !== 'function') {
      return;
    }
    if (container.matches && container.matches('[data-sbb-root]')) {
      callback(container);
    }
    if (!container.querySelectorAll) {
      return;
    }
    var roots = container.querySelectorAll('[data-sbb-root]');
    roots.forEach(function (root) {
      callback(root);
    });
  }

  function autoMount(container) {
    forEachBuilderRoot(container || document, function (root) {
      mountScaleBarBuilder(root);
    });
  }

  function autoUnmount(container) {
    forEachBuilderRoot(container || document, function (root) {
      unmountScaleBarBuilder(root);
    });
  }

  function bindShopifySectionLifecycle() {
    if (document.__sbbShopifyLifecycleBound) {
      return;
    }
    document.__sbbShopifyLifecycleBound = true;
    document.addEventListener('shopify:section:load', function (event) {
      autoMount(event && event.target ? event.target : document);
    });
    document.addEventListener('shopify:section:unload', function (event) {
      autoUnmount(event && event.target ? event.target : document);
    });
  }

  function initAutoMount() {
    autoMount(document);
    bindShopifySectionLifecycle();
  }

  function resolveMountedBuilder(target) {
    if (target && typeof target === 'object') {
      if (target.__sbbMounted) {
        return target.__sbbMounted;
      }
      if (typeof target.applyTemplateById === 'function' && typeof target.getTemplateList === 'function') {
        return target;
      }
    }
    var root = null;
    if (typeof target === 'string') {
      root = document.querySelector(target);
    } else if (target && target.nodeType === 1) {
      root = target;
    } else {
      root = document.querySelector('[data-sbb-root]');
    }
    if (root && root.__sbbMounted) {
      return root.__sbbMounted;
    }
    return null;
  }

  window.ScaleBarBuilderMount = mountScaleBarBuilder;
  window.ScaleBarBuilderUnmount = unmountScaleBarBuilder;
  window.ScaleBarBuilderBindShopifyLifecycle = bindShopifySectionLifecycle;
  window.ScaleBarBuilderTemplates = {
    list: function (target) {
      var app = resolveMountedBuilder(target);
      return app ? app.getTemplateList() : [];
    },
    apply: function (templateId, target, options) {
      var app = resolveMountedBuilder(target);
      return app ? app.applyTemplateById(templateId, options || {}) : false;
    },
    register: function (definitions, target, options) {
      var app = resolveMountedBuilder(target);
      if (!app) {
        return { added: 0, updated: 0, skipped: 0, total: 0, error: 'no_builder' };
      }
      return app.registerTemplateDefinitions(definitions, options || {});
    },
    importJson: function (rawText, target, options) {
      var app = resolveMountedBuilder(target);
      if (!app) {
        return { added: 0, updated: 0, skipped: 0, total: 0, error: 'no_builder' };
      }
      return app.importTemplateJson(rawText, options || {});
    },
    exportJson: function (target, options) {
      var app = resolveMountedBuilder(target);
      return app ? app.exportTemplateJson(options || {}) : '';
    },
    exportCurrent: function (meta, target, options) {
      var app = resolveMountedBuilder(target);
      return app ? app.exportCurrentAsTemplate(meta || {}, options || {}) : null;
    },
    clear: function (target, options) {
      var app = resolveMountedBuilder(target);
      return app ? app.clearTemplateLibrary(options || {}) : false;
    },
    reload: function (target) {
      var app = resolveMountedBuilder(target);
      if (!app) {
        return false;
      }
      app.loadTemplateLibrary();
      app.setStatus('Template library reloaded.', false);
      return true;
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAutoMount);
  } else {
    initAutoMount();
  }
})();
